import { render, staticRenderFns } from "./SaleEditDesktopTableRow.vue?vue&type=template&id=533a1634&scoped=true"
import script from "./SaleEditDesktopTableRow.vue?vue&type=script&lang=ts"
export * from "./SaleEditDesktopTableRow.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditDesktopTableRow.vue?vue&type=style&index=0&id=533a1634&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a1634",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533a1634')) {
      api.createRecord('533a1634', component.options)
    } else {
      api.reload('533a1634', component.options)
    }
    module.hot.accept("./SaleEditDesktopTableRow.vue?vue&type=template&id=533a1634&scoped=true", function () {
      api.rerender('533a1634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditDesktopTableRow.vue"
export default component.exports